define([
    "dojo/_base/declare",
    "dojo/_base/lang",
    "csi/table/AggregateFrom",
    "csi/xml"
], function (declare, lang, AggregateFrom, xml) {
    return declare(AggregateFrom, {
        getFormData: function () {
            // summary: disable Save button if no theme is selected
            var fd = this.inherited(arguments);
            fd.m_fAggregateTest = lang.hitch(this, this._canAggregateSeasonableItem);
            return fd;
        },
        _canAggregateSeasonableItem: function (/*Context*/ctx, /*FormData*/fd) {
            // summary: only allow selection of nodes with Write access
            return xml.nodeHasRight(ctx.getNode(), xml.RIGHT_WRITE);
        }
    });
});